import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d851b45"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Home", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("One platform."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Infinite possibilities.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "third" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "right" }, "Welcome to Derivitec")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two-thirds" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Complete transparency across all stakeholders"),
  /*#__PURE__*/_createElementVNode("p", null, "Available out of the box as a powerful web application, or integrated directly into the client’s own applications, Derivitec covers your risk needs from initial analysis to final attribution, providing complete transparency across all stakeholders in your organisation."),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("Understand your risk. "),
    /*#__PURE__*/_createElementVNode("em", null, "Properly.")
  ])
], -1))
const _hoisted_5 = { class: "half" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "What we can do for you", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Hedge Funds", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ensure complete consistency across your organisation, front to back, pre and post trade, real time and end of day. View your risk in whatever way best fits your portfolio. The only limit is your imagination.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "third" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "What we can do for you")
], -1))
const _hoisted_10 = { class: "half" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Remittance Companies", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Understand the risk on your collateral, to your liquidity providers, from your clients. Make sure you know who’s not going to be able to pay margin before it happens.", -1))
const _hoisted_13 = { class: "half" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "What we can do for you", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Platforms", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Service the risk reporting needs of your client funds through a single application. See the complete risk picture across all your companies.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_panel, {
      class: "hedge columns",
      bg: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_router_link, {
            class: "button light",
            to: "/hedge-funds"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "remittance columns" }, {
      default: _withCtx(() => [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_router_link, {
            class: "button",
            to: "/remittance-funds"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_panel, {
      class: "platforms columns",
      bg: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _createVNode(_component_router_link, {
            class: "button light",
            to: "/platforms"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}